import React from "react";
import { Route } from "react-router-dom";

import Layout from "@ROM-pages/Layouts/CustomerAdmin";
import Page from "./Page";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Page />
      </Layout>
    );
  }
}

export default RouteHandler;
